import { createRouter, createWebHistory } from "vue-router";

import Login from "@/views/LoginView.vue";
import Admin from "@/views/AdminView.vue";
// import Dashboard from "@/views/DashboardView.vue";
import AdminDashboard from "@/views/DashboardView.vue";
import Tickets from "@/views/TicketsView.vue";
import MyTickets from "@/views/MyTicketsView.vue";
import TicketDetails from "@/views/TicketDetailsView.vue";
import TicketSms from "@/views/TicketSMS.vue";
import CallAttempts from "@/views/CallAttemptsView.vue";
import Calendar from "@/views/CalendarView.vue";
import Users from "@/views/UsersView.vue";
import Clients from "@/views/ClientsView.vue";
import Activity from "@/views/ActivityLogsView.vue";
import Reports from "@/views/ReportsView.vue";
import UploadStatement from "@/views/UploadStatement.vue";
import Test from "@/views/TestView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Login,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: AdminDashboard,
      },
      {
        path: "tickets",
        name: "Tickets",
        component: Tickets,
      },
      {
        path: "tickets/:id",
        name: "Ticket",
        component: TicketDetails,
      },
      {
        path: "tickets/:id/sms",
        name: "TicketSms",
        component: TicketSms,
      },
      {
        path: "my-tickets",
        name: "My Tickets",
        component: MyTickets,
      },
      {
        path: "call-attempts",
        name: "Call Attempts",
        component: CallAttempts,
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar,
      },
      {
        path: "users",
        name: "Users",
        component: Users,
      },
      {
        path: "clients",
        name: "Clients",
        component: Clients,
      },
      {
        path: "activity-logs",
        name: "Activity Logs",
        component: Activity,
      },
      {
        path: "reports",
        name: "Reports",
        component: Reports,
      },
      {
        path: "upload-statement",
        name: "Upload Statement",
        component: UploadStatement,
      },
      {
        path: "sms/:id",
        name: "Test",
        component: Test,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
